var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"error","dense":"","value":_vm.errors && _vm.errors.length > 0}},_vm._l((_vm.errors),function(e,i){return _c('div',{key:i},[_vm._v(_vm._s(e))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }